import { PerformanceIcon } from '@components/icons/PerformanceIcon'
import { FlexRow } from '@components/shared/FlexRow'
import { FormField, SelectOption } from '@components/shared/FormField'
import { DecimalFormat, PercentFormat } from '@components/shared/Format'
import { GoldCard } from '@components/shared/GoldCard'
import { I18n } from '@components/shared/I18n'
import { Table, TableCell, TableRow } from '@components/shared/Table'
import { CountryInfoUrlKey } from '@models/CountryInfo'
import { SectionComponent, SectionKey } from '@sections/SectionComponent'
import { StoreProps } from '@stores/Store'
import { I18nKey } from '@utils/i18n'
import { Form } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'
import styles from './PerformancePlusSection.module.scss'

interface PerformancePlusFormData {
  performancePlusTracking?: boolean
}

const booleanOptions: SelectOption<boolean>[] = [
  { label: 'YES', value: true },
  { label: 'NO', value: false }
]

@inject('store')
@observer
export class PerformancePlusSection extends SectionComponent<StoreProps, {}> {
  static defaultProps = {} as StoreProps
  static get title(): I18nKey { return 'SECTION_PERFORMANCE_PLUS_INCENTIVES' }
  static get icon() { return <PerformanceIcon /> }
  static get trackerKey() { return 'C+plus' }

  onValuesChange = (data: PerformancePlusFormData) => {
    const { store } = this.props
    const { performancePlusStore } = store
    if ('performancePlusTracking' in data) { performancePlusStore.setPerformancePlusTracking(data.performancePlusTracking!) }
    store.globalStore.updateSectionUsage(SectionKey.PERFORMANCE_PLUS)
  }

  render() {
    const { store } = this.props
    const { performancePlusStore, localizationHelper } = store
    const { performancePlusMonthlyPpvValue, performancePlusPerformanceBonusMonthlyMultipier, performancePlusAnnualAmount } = store.performancePlusCalculation
    const { PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT_KEY, PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT_KEY, INFO_PERFORMANCE_PLUS_KEY  } = localizationHelper
    const { performancePlusTracking } = performancePlusStore

    return (
      <>
        <div className={styles['container-info']}>
          <div className={styles['title']}>
            <I18n name='PERFORMANCE_PLUS_TITLE' />
          </div>
          <div className={styles['container-box']}>
            <div className={styles['box']}><I18n name={PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT_KEY} /></div>
            <div className={styles['box']}><I18n name={PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT_KEY} /></div>
            <div className={styles['circle']}><I18n name='OR' /></div>
          </div>
        </div>
        <Form className='section' layout='vertical'
          initialValues={{ performancePlusTracking }}
          onValuesChange={this.onValuesChange}>
          <FlexRow collapse>
            <FormField name="performancePlusTracking" type='select' label='SILVER_TRACKING' options={booleanOptions} />
            <div />
          </FlexRow>
        </Form>
        <Table>
          <TableRow header>
            <TableCell><I18n name='MONTHLY_PPV_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={performancePlusMonthlyPpvValue} /></TableCell>
          </TableRow>
          <TableRow>
            <TableCell><I18n name='PBMM' /></TableCell>
            <TableCell align='right'><PercentFormat value={performancePlusPerformanceBonusMonthlyMultipier}></PercentFormat></TableCell>
          </TableRow>
        </Table>
        <div className='section section-rewards'>
          {performancePlusAnnualAmount === 0 ? (
            <GoldCard title='CP_PERFORMANCE_PLUS_DISABLED' disabled infoContent={INFO_PERFORMANCE_PLUS_KEY} infoUrl={CountryInfoUrlKey.INFO_PERFORMANCE_PLUS_URL}></GoldCard>
          ) : (
            <GoldCard title='CP_PERFORMANCE_PLUS' value={performancePlusAnnualAmount} period='PER_YEAR'></GoldCard>
          )}
        </div>
      </>
    )
  }
}
